/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Set grid spacing and snapping threshold</h4>

<p>Set the spacing of the grid lines (and snapping threshold) based on the current workspace units. Check the checkbox to center the grid on a single selected vertex.</p>`;

export default function ShowGridsizeModalTooltip() {
    return h('div', { innerHTML: body });
}
